import { mockData as users } from '@web/lib/demo/data/users';
import { diffComparisonType, diffComparisonValueFormat } from '@workalizer/shared/types';
import { formatDuration, getPercentageDiff } from '@workalizer/shared/utils';
var buildRow = function (userIndex, responses, prevResponses, teamAvgResponses, avgResponseTimeSeconds, prevAvgResponseTimeSeconds, teamAvgResponseTimeSeconds) { return ({
    userId: userIndex + 1,
    userName: users[userIndex].name,
    userEmail: users[userIndex].email,
    responses: responses,
    avgResponseTime: formatDuration(avgResponseTimeSeconds, 'seconds'),
    prevResponses: getPercentageDiff(prevResponses, responses),
    prevAvgResponseTime: getPercentageDiff(prevAvgResponseTimeSeconds, avgResponseTimeSeconds, { comparisonValueFormat: diffComparisonValueFormat.durationSeconds }),
    teamAvgResponses: getPercentageDiff(teamAvgResponses, responses, {
        comparisonType: diffComparisonType.teamAverage
    }),
    teamAvgResponseTime: getPercentageDiff(teamAvgResponseTimeSeconds, avgResponseTimeSeconds, {
        comparisonValueFormat: diffComparisonValueFormat.durationSeconds,
        comparisonType: diffComparisonType.teamAverage
    })
}); };
export var emailResponseSpeedAndFrequency = function (_input) {
    var data = [
        buildRow(0, 15, 12, 11, 300, 333, 320),
        buildRow(1, 8, 7, 10, 180, 189, 210),
        buildRow(2, 12, 13, 9, 420, 375, 390),
        buildRow(3, 6, 4, 8, 120, 160, 150),
        buildRow(4, 20, 19, 14, 240, 282, 260),
        buildRow(5, 3, 1, 5, 60, 120, 90),
        buildRow(6, 25, 28, 18, 360, 333, 345),
        buildRow(7, 10, 8, 12, 240, 282, 255)
    ];
    return data.sort(function (a, b) { return b.responses - a.responses; });
};
